"use client";
import { SocialDriverTypes } from "@/api/AppApi/services/auth/interfaces/IAuth";
import { Col, Row } from "@/utils/bootstrap";
import SocialButton from "./auth-social-helpers/SocialButton";
import SocialOr from "./auth-social-helpers/SocialOr";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useState } from "react";
import AppToast from "@/app/components/lib/toast/AppToast";

const SocialButtons = () => {
  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const enable_social_login = company?.theme?.settings?.enable_social_login;
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  if (!enable_social_login) return null;

  return (
    <>
      <SocialOr />
      <AppToast
        show={showToast}
        setShow={setShowToast}
        message={<div>{toastMsg}</div>}
        danger
        top
      />
      <div style={{ position: "relative" }}>
        <Row className="m-0 w-100" style={{ gap: 16 }}>
          {Object.values(SocialDriverTypes).map((driver, index) => (
            <Col key={index} className="p-0">
              <SocialButton
                driver={driver}
                onError={(msg) => {
                  setToastMsg(msg);
                  setShowToast(true);
                }}
              />
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

export default SocialButtons;
